import { Limiting } from '@api/Celebrities';
import useTranslation from 'next-translate/useTranslation';
import React, { HTMLAttributes } from 'react';
import { I18N_PROFILE_CONTEXT, REQUESTS_LEFT, SOLD_OUT } from '../ProfileForm.constants';
import { FireSVG, PriceBadgeStyle as PriceBadgeWrapper, TagSVG } from './PriceBadge.styles';

export const PriceBadge = ({ enabled, soldOut, remainingSlots, ...props }: Limiting & HTMLAttributes<HTMLDivElement>): JSX.Element => {
  const { t } = useTranslation(I18N_PROFILE_CONTEXT);

  const soldOutView = (
    <PriceBadgeWrapper {...props}>
      <TagSVG width={16} height={16} />
      {t(SOLD_OUT)}
    </PriceBadgeWrapper>
  );

  const remainingView = (
    <PriceBadgeWrapper {...props}>
      <FireSVG width={16} height={16} />
      {t(REQUESTS_LEFT, { remainingSlots: remainingSlots })}
    </PriceBadgeWrapper>
  );

  if (!enabled) return <></>;

  if (soldOut) return soldOutView;

  return remainingView;
};
